import { useQuery } from "@tanstack/vue-query";
import { type Ref } from "vue";
import { api } from "@/api";
import { type BaseReportFilters } from "./reports";

export const REPORT_DATA_QUALITY_QUERY_KEY = "data-quality-reports";

export type DataQualityReportRow = {
  siteName: string;
  totalArrivals: number;
  totalAnyDefect: number;
  percentageAnyDefect: string;
  totalNoRegistration: number;
  percentageNoRegistration: string;
  totalInvalidRegistration: number;
  percentageInvalidRegistration: string;
  totalNoPhone: number;
  percentageNoPhone: string;
  totalInvalidPhone: number;
  percentageInvalidPhone: string;
};

export type DataQualityReport = DataQualityReportRow[];

export const retrieveDataQualityReport = async (query: BaseReportFilters) => {
  const { body } = await api.get<DataQualityReport>("/reports/data-quality/", {
    query: query,
  });

  return body;
};

export const useDataQualityReport = (
  filters: BaseReportFilters | Ref<BaseReportFilters>,
) => {
  return useQuery({
    queryKey: [REPORT_DATA_QUALITY_QUERY_KEY, filters] as const,
    queryFn: ({ queryKey: [_, query] }) =>
      retrieveDataQualityReport(unref(query)),
    staleTime: 60 * 60 * 1000,
  });
};

export const exportDataQualityReport = async (query: BaseReportFilters) => {
  const data = await api.get<Blob>("/reports/data-quality/export/", {
    query: query,
  });

  return exportFileFromRespone(data);
};
